import React, { useEffect, useState } from 'react'
import CommonTable from '../../components/Table/CommonTable';
import { API_END_POINT, TOKEN } from '../../constant';
import axios from 'axios';
import Loader from '../../components/Loader/Loader';
import { useNavigate } from 'react-router-dom';
import ReportDownload from '../../assets/Report/ReportDownload.png'
import './Report.css'
import { toast } from 'react-toastify';
import { Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { pdfjs } from "react-pdf"; 
import { TbDownload } from "react-icons/tb";
pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.0.279/pdf.worker.min.js'



function Report() {
    const [pdfPath, setPdfPath] = useState(null);
    const [loading, setLoading] = useState(false);
    const [listUsers, setUsersList] = useState([]);
    const [subusers, setSubUsers] = useState([])
    const [hideTable, setHideTable] = useState(true)
    const navigate = useNavigate();
    const [report, setReport] = useState()
    const [openPopup, setOpenPopup] = useState(false)
    const [option, setOption] = useState(null)
    const [id, setId] = useState(null)
    const [subId, setSubId] = useState(null)
    const [totalRows, setTotalRows] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [subUserLength, setSubUserLength] = useState(null)
    const [reportLength, setReportLength] = useState(null)

    useEffect(() => {
        getList(currentPage);
    }, [currentPage])

    // Handle page change
    const handlePageChange = (page) => {
        console.log("this is change pae", page)
        setCurrentPage(page);
    };

    const getList = async (page) => {
        try {
            setLoading(true);
            const headers = {
                Authorization: `Bearer ${TOKEN}`
            };
            // const response = await axios.get(`${API_END_POINT}reportSubscriptionMaster/allUsersWithSubUsers`, { headers });
            const response = await axios.get(`${API_END_POINT}reportSubscriptionMaster/allUsersSubUsersWithSearch?page=${page - 1}&size=10&search=`, { headers });
            setLoading(false)
            // console.log("Response through Report.jsx is :", response)
            console.log("Main List:", response?.data.content)
            setUsersList(response?.data.content)
            setTotalRows(response?.data.totalElements)
        } catch (error) {
            setLoading(false);
        }
    }

    //when click on subuser button in user table
    const handleIdClick = (prevUserId) => {
        console.log(listUsers)
        // console.log("wiwi", prevUserId)
        const selectedUser = listUsers.find((item) => item.userId === prevUserId);
        // console.log(selectedUser)
        if (selectedUser) {
            setSubUsers(selectedUser.subUsers);
            setSubUserLength(selectedUser.subUsers.length)
            console.log(selectedUser.subUsers.length)
        }
        // console.log("Subusers :", selectedUser.subUsers);
        setId(prevUserId)
        setHideTable(false)
        setOption(null)
    };

    //when click on subuser table row
    const handleSubidClick = (subid) => {
        console.log(id)
        // console.log(subusers)
        const reportSelectedUser = subusers.find((item) => item.subUserId === subid);
        // console.log(reportSelectedUser)
        setSubId(reportSelectedUser.subUserId)
        if (reportSelectedUser) {
            setReport(reportSelectedUser.reportList);
            setReportLength(reportSelectedUser.reportList.length)
            console.log(reportSelectedUser.reportList.length)
        }
        // console.log("Report :", report)
        setHideTable('report');
    }

    //when click on report button in user table
    const handleReportClick = (id) => {
        // console.log(listUsers)
        // console.log(id)
        setId(id)
        const reportUser = listUsers.find((item) => item.userId === id);
        // console.log(reportUser)
        if (reportUser) {
            setReport(reportUser.userReportList);
            setReportLength(reportUser.userReportList.length)
            console.log(reportUser.userReportList.length)
        }
        // console.log("Report User:", reportUser.userReportList)
        setHideTable('report2');
    }

    //User Table
    const columns = [
        {
            name: 'Sr. No.',
            cell: (row, index) => index + 1,
        },
        {
            name: "Name",
            cell: (row) => row?.userName
        },
        {
            name: "Mobile No.",
            cell: (row) => row?.userMobileNo
        },
        {
            name: "Email Id",
            cell: (row) => row?.userEmail
        },
        {
            name: "D.O.B.",
            cell: (row) => row?.userDateOfBirth
        },
        {
            name: "Place Of Birth",
            cell: (row) => row?.userBirthPlace
        },
        {
            name: "Gender",
            cell: (row) => row?.userGender
        },
        {
            name: "Options",
            cell: (row) => (
                <div className='btn'>
                    <button onClick={() => { handleIdClick(row.userId); }}>Subuser</button>
                    <button onClick={() => { handleReportClick(row.userId); }}>Report</button>
                </div>
            )
        },
    ];

    // const handleReportDownloadClick = async (reportId) => {
    //     setLoading(true)
    //     console.log("this is the id of user ", id)
    //     const handleReportDownloadUrl = `${API_END_POINT}fileAttachment/report/download?userId=${id}&subUserId=0&subscriptionModuleId=${reportId}`
    //     const handleReportDownloadHeaders = {
    //         'Authorization': `Bearer ${TOKEN}`
    //     }
    //     try {
    //         const response = await axios.get(handleReportDownloadUrl, {
    //             headers: handleReportDownloadHeaders,
    //             // responseType: 'blob', 
    //         })
            
    //         console.log("this is the response --->>> ", response.data)
    //         const pdfData = new TextEncoder().encode(response.data);

    //         const blob = new Blob([pdfData], { type: 'application/pdf' });
    //         const filePath = URL.createObjectURL(blob);

    //         setPdfPath(filePath);            

    //         setTimeout(()=>{
    //             downloadPdf()
    //         },2000)

    //     } catch (error) {
    //         toast.error("failed to load report");
    //         console.log("error Report.jsx --->>> handleReportDownloadClick() ", error);
    //     } finally {
    //         setLoading(false)
    //     }
    // }

    //subUser Table
    
    const handleReportDownloadClick = async (reportId) => {
        setLoading(true);
        console.log("this is the id of user ", id);
        const handleReportDownloadUrl = `${API_END_POINT}fileAttachment/report/download?userId=${id}&subUserId=${subId ?? 0}&subscriptionModuleId=${reportId}`;
        const handleReportDownloadHeaders = {
            'Authorization': `Bearer ${TOKEN}`
        };
    
        try {
            const response = await axios.get(handleReportDownloadUrl, {
                headers: handleReportDownloadHeaders,
                responseType: 'arraybuffer', // Get the binary PDF data
            });
    
            console.log("this is the response --->>> ", response.data);
    
            // Create a Blob from the binary data
            const blob = new Blob([response.data], { type: 'application/pdf' });
    
            // Create a URL for the Blob
            const filePath = URL.createObjectURL(blob);
    
            // Create an anchor tag to initiate the download
            const link = document.createElement('a');
            link.href = filePath;
            link.download = `report_${reportId}.pdf`;  // Set the file name for download
    
            // Programmatically click the link to trigger the download
            link.click();
    
            // Clean up by revoking the object URL
            URL.revokeObjectURL(filePath);
        } catch (error) {
            toast.error("Failed to load report");
            console.log("Error in handleReportDownloadClick:", error);
        } finally {
            setLoading(false);
        }
    };
    

    const columns2 = [
        {
            name: 'Sr. No.',
            cell: (row, index) => index + 1,
        },
        {
            name: "Name",
            cell: (row) => row?.name
        },
        {
            name: "Mobile No.",
            cell: (row) => row?.mobileNo
        },
        {
            name: "Email Id",
            cell: (row) => row?.email
        },
        {
            name: "D.O.B.",
            cell: (row) => row?.dateOfBirth
        },
        {
            name: "Place Of Birth",
            cell: (row) => row?.birthPlace
        },
        {
            name: "Gender",
            cell: (row) => row?.gender
        },
    ];

    //Report Table
    const columns3 = [
        {
            name: 'Sr. No.',
            cell: (row, index) => index + 1,
        },

        {
            name: "Report Name",
            cell: (row) => row?.reportName
        },
        {
            name: "Purchase",
            cell: (row) => {
                return (
                    < div className="button r" id="button-1" >
                        <input type="checkbox" className="checkbox" checked={row.reportPurchased}
                            onChange={() => (handleCheckboxChange(row))} />
                        <div className="knobs"></div>
                        <div className="layer"></div>
                    </div >
                )
            }
        },
        {
            name: "Download Report",
            cell: (row) => {
                return (
                    <div onClick={() => handleReportDownloadClick(row?.reportId)} >
                        <img src={ReportDownload} alt="downloadIcon" />
                    </div>
                )
            }
        },
    ];

    const handleCheckboxChange = async (value) => {
        // console.log(value)
        console.log(id)
        // console.log(value.reportPurchased)
        // console.log("Report item toggled:", value);
        const newAccessStatus = !value.reportPurchased; // Toggle the current status
        // console.log("New access status:", newAccessStatus);

        const data = {
            userId: id,
            subUserId: hideTable === 'report2' ? 0 : subId,
            packageId: value.reportId,
            access: newAccessStatus, // Correctly toggle the boolean
        }
        try {
            // console.log("Access updated successfully:", response);
            const updatedReport = report.map((item) =>
                item.reportId === value.reportId
                    ? { ...item, reportPurchased: newAccessStatus }
                    : item
            );
            setReport(updatedReport);
            const response = await axios.post(`${API_END_POINT}reportSubscriptionMaster/manageReportAccess`, data, {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${TOKEN}`
                }
            })
        }
        catch (error) {
            console.log(error)
        }
    }

    const handleBackClick = () => {
        setSubId(null)
        console.log("this is handleBackClick")
        setHideTable(true);
    };

    const handleBackClick2 = () => {
        console.log("this is handleBackClick2")

        setHideTable(false)
    }

    const handleBackClick3 = () => {
        console.log("this is handleBackClick3")
        setHideTable(true)
    }

    const SearchBar = async (e) => {
        console.log(e.target.value)
        try {
            const resp = await axios.get(`${API_END_POINT}reportSubscriptionMaster/allUsersSubUsersWithSearch?page=0&size=10&search=${e.target.value}`, {
                headers: {
                    'Authorization': `Bearer ${TOKEN}`
                }
            });
            console.log("Response from search bar is ", resp)
            setUsersList(resp?.data.content)
            // if (resp.data.size )
            // if (e.target.value !== "") {
            //     setUsersList(resp?.data.content)
            // }
            // else {
            //     // getList()
            //     setUsersList(resp?.data.content)
            // }
        }
        catch (error) {
            console.log(error)
        }
    }

    const downloadPdf = () => {
        setLoading(true);

        if (!pdfPath) {
            setLoading(false);
            alert("PDF path is undefined");
            return;
        }

        const timestamp = Date.now();
        const uniqueFileName = `report}-${timestamp}.pdf`;
        const link = document.createElement("a");
        link.download = uniqueFileName;
        link.href = pdfPath;
        link.click();
        setLoading(false);
    };


    return (
        <main className='main'>
            
            {pdfPath ? ( 
                 <div
            
                className="fluid"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100vh",
                    padding: "18px",
                    height: "calc(100vh - 100px)",
                }}
            >
                {/* Header */}
                <div className="d-flex justify-content-center">
                    <h1
                        style={{
                            color: "#ae285d",
                            fontSize: "1.4rem",
                            fontWeight: 600,
                            borderBottom: "3px solid #ae285d",
                            paddingBottom: "5px",
                            maxWidth: "250px",
                            width: "80%",
                            textAlign: "center",
                        }}
                    >
                        no title
                    </h1>
                </div>
                {/* PDF Viewer */}
                <div
                    style={{
                        flex: 1,
                        padding: "10px",
                        borderRadius: "8px",
                        overflow: "hidden",
                    }}
                    className="fluid border shadow-sm rounded"
                >
                    {pdfPath ? (
                        <Viewer
                            fileUrl={pdfPath}
                            onError={(error) => {
                                console.error("PDF Load Error: ", error);
                                alert("An error occurred while displaying the PDF.");
                            }}
                            style={{
                                height: "100%",
                                width: "100%",
                                borderRadius: "8px",
                                overflow: "hidden",
                            }}
                        />
                    ) : (
                        <p>No PDF available to display.</p>
                    )}
                </div>
                <TbDownload
                    onClick={downloadPdf}
                    style={{
                        position: "absolute",
                        bottom: "48px",
                        right: "58px",
                        padding: "12px",
                        backgroundColor: "#ffa732",
                        color: "#000",
                        border: "none",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        transition: "background-color 0.3s, transform 0.3s",
                        fontSize: "44px",
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#ae285d";
                        e.target.style.color = "#ffffff";
                        e.target.style.transform = "scale(1.1)";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#ae285d";
                        e.target.style.color = "#ffffff";
                        e.target.style.transform = "scale(1)";
                    }}
                />
            </div>
        //     <iframe
        //     src={pdfPath}
        //     width="100%"
        //     height="600px"
        //     style={{ border: 'none', marginTop: '20px' }}
        //     title="PDF Report"
        // /> 
            ) : (
                <>
                <h3 className='heding' style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                {
                    hideTable == true ? 'User Table' : (
                        hideTable === false ? 'Subuser Table' : (
                            hideTable === 'report' ? 'Report Table' : 'Report Table'
                        )
                    )
                }
            </h3>

            <div id='search-div' style={{ marginBottom: '10px' }}>
                {
                    hideTable === true ? <form className='flex flex-wrap aign-center gap-5 magazinesConfigurationForm form'>
                        <div className='input-field flex ' style={{ alignItems: 'center', gap: '8px' }} >
                            <label htmlFor="searchName">Search Bar</label>
                            <input type="text" id='searchName' placeholder='Search Here' onChange={SearchBar} />
                        </div>
                    </form> : null
                }
                {
                    hideTable === true ? null :
                        (hideTable === false ?
                            <div className='flex align-center justify-end'>
                                <button className='common-btn flex align-center' onClick={handleBackClick}>
                                    <svg width="27" height="27" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="m15 18-6-6 6-6"></path>
                                    </svg>
                                </button>
                            </div> :
                            (hideTable !== 'report2' ?
                                <div className='flex align-center justify-end'>
                                    <button className='common-btn flex align-center' onClick={handleBackClick2}>
                                        <svg width="27" height="27" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="m15 18-6-6 6-6"></path>
                                        </svg>
                                    </button>
                                </div> : <div className='flex align-center justify-end'>
                                    <button className='common-btn flex align-center' onClick={handleBackClick3}> 
                                        <svg width="27" height="27" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="m15 18-6-6 6-6"></path>
                                        </svg>
                                    </button>
                                </div>
                            )
                        )
                }
            </div>

            <CommonTable
                columns={hideTable === true ? columns : (hideTable === false ? columns2 : columns3)}
                data={hideTable === true ? listUsers : (hideTable === false ? subusers : report)}
                handleSubidClick={handleSubidClick}
                hideTable={hideTable}
                handlePageChange={handlePageChange}
                // totalRows={totalRows}
                totalRows={hideTable === true ? totalRows : (hideTable === false ? subUserLength : reportLength)}
                value={true}
            />
                </>
            )}

            {/* ------- loader here ------- */}
            {loading && <Loader />}
        </main>
    )
}

export default Report